'use strict';

var App = require('app');
var AppState = require('app_state');
var HomeController = require('components/home/home_controller');
var HelpViews = require('components/help/views/views');
var i18n = require('utils/i18n');
var Notification = require('utils/notification');
var Strings = require('utils/strings');

var HelpController = {};

HelpController.showSupport = function () {
    HomeController.showBaseLayout({
        cb: function () {
            AppState.layout.breadcrumbs.reset();
            App.trigger('sidebar:default');
            App.showContentView(new HelpViews.Support());
        },
    });
};

HelpController.showImprint = function () {
    HomeController.showBaseLayout({
        cb: function () {
            AppState.layout.breadcrumbs.reset();
            App.trigger('sidebar:default');
            App.showContentView(new HelpViews.Imprint());
        },
    });
};

HelpController.showTerms = function () {
    HomeController.showBaseLayout({
        cb: function () {
            var termsFetched = $.get('/lang/' + i18n.language + '_terms.html');

            $.when(termsFetched)
                .done(function (terms) {
                    AppState.layout.breadcrumbs.reset();
                    App.trigger('sidebar:default');
                    App.showContentView(new HelpViews.Terms({ title: i18n.TR('Nutzungsbedingungen'), content: terms }));
                })
                .fail(function () {
                    Notification.show(
                        'error',
                        i18n.TR('Fehler'),
                        i18n.TR('Nutzungsbedingungen konnten nicht geladen werden.')
                    );
                });
        },
    });
};

HelpController.showDataProtection = function () {
    HomeController.showBaseLayout({
        cb: function () {
            var gdprFetched = $.get('/lang/' + i18n.language + '_gdpr.html');

            $.when(gdprFetched)
                .done(function (terms) {
                    AppState.layout.breadcrumbs.reset();
                    App.trigger('sidebar:default');
                    App.showContentView(new HelpViews.Terms({ title: i18n.TR('Datenschutzhinweis'), content: terms }));
                })
                .fail(function () {
                    Notification.show(
                        'error',
                        i18n.TR('Fehler'),
                        i18n.TR('Datenschutzhinweis konnte nicht geladen werden.')
                    );
                });
        },
    });
};

HelpController.getHelpTour = function (route, onlyLook) {
    var d = $.Deferred();
    var method = onlyLook ? 'HEAD' : 'GET';
    // construct path to file. Example for german language:
    // gateway/3/status-log" -> "/help/de_gateway_status-log.txt"
    var serverUrl = Strings.urlToPath(route);
    App.ajax({
        url: serverUrl,
        method: method,
        success: function (result) {
            if (typeof result === 'string') {
                result = JSON.parse(result);
            }
            d.resolve(result || '');
        },
        error: function () {
            d.resolve(undefined);
        },
    });
    return d.promise();
};

module.exports = HelpController;
